import { TranslateService } from '@ngx-translate/core';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CredentialsService } from '@shared/services/web/credentials.service';
import { AuthenticationService } from '@app/auth/authentication.service';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss'],
})
export class VerifyAccountComponent implements OnInit {
  hash = '';
  verified = false;
  error = false;
  verifyOffer = 0;
  redirectReference: string = null;
  userData: any = null;
  isLoading = true;
  constructor(
    private activatedRoute: ActivatedRoute,
    private credentialsService: CredentialsService,
    private authenticationSvc: AuthenticationService,
    public translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.hash = this.activatedRoute.snapshot.paramMap.get('hash');
  }

  ngOnInit() {
    this.isLoading = true;
    // Verifying consumes the hash: never run it during SSR, or the browser
    // would receive an already-used hash and show the error screen.
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    let parametrosUrl: any = {};
    this.activatedRoute.queryParams.subscribe((params) => {
      parametrosUrl = params;
    });
    this.authenticationSvc.loginWithHash(this.hash).subscribe({
      next: (res: any) => {
        this.verifyOffer = 1;
        this.userData = this.credentialsService?.credentials;
        this.redirectReference = parametrosUrl.redirectTo;
        this.isLoading = false;
        this.validateUser();
      },
      error: (error) => {
        this.verifyOffer = 3;
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  validateUser() {
    this.isLoading = true;
    if (this.userData?.verified) {
      this.verifyOffer = 2;
      this.isLoading = false;
      return;
    }
    this.authenticationSvc.verifyAccount(this.hash).subscribe({
      next: (res: any) => {
        this.credentialsService.setCredentials({
          ...this.userData,
          verified: true,
        });
        this.verifyOffer = 2;
      },
      error: (error) => {
        this.verifyOffer = 3;
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
}
